import React from 'react';
import PowerOffIcon from '@mui/icons-material/PowerOff';

interface StateIconProps {
  opcuaconnectionstatus: number; // 1 for connected, 0 for disconnected
  currentstate: number;           // ENUM values 0-9
}

const StateIcon: React.FC<StateIconProps> = ({ opcuaconnectionstatus, currentstate }) => {
  // 1. Check Connection State first
  if (opcuaconnectionstatus === 0 || opcuaconnectionstatus === undefined || opcuaconnectionstatus === null) {
    return (
      <div className="state-icon-container">
        <PowerOffIcon style={{ fontSize: '20px', color: '#666' }} />
      </div>
    );
  }

  // 2. Determine color for Connected State
  // Colors mapped based on ENUM definitions
  let backgroundColor: string;

  switch (currentstate) {
    case 4: // operating
      backgroundColor = '#4caf50'; // Green
      break;
    case 7: // notice
      backgroundColor = '#4caf50'; // Green
      break;
    case 8: // warning
      backgroundColor = '#ffeb3b'; // Yellow
      break;
    case 9: // error
      backgroundColor = '#f44336'; // Red
      break;
    default:
      backgroundColor = 'transparent'; // Grey for Unknown (0) or Reserved (1,2,3,5,6)
  }

  let emptyState = currentstate === 0 || [1, 2, 3, 5, 6].includes(currentstate);

  return (
    <div 
      style={{
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        backgroundColor,
        border: '1.5px solid '+ (emptyState ? "rgb(140 140 140)" : "rgb(235 235 235)"), // Adds visibility against the machine image
        // boxShadow: '0px 2px 4px rgba(0,0,0,0.2)'
      }} 
    />
  );
};

export default StateIcon;